import { render, staticRenderFns } from "./SelectCasePageContent.vue?vue&type=template&id=4a0301a8&scoped=true"
import script from "./SelectCasePageContent.vue?vue&type=script&lang=ts"
export * from "./SelectCasePageContent.vue?vue&type=script&lang=ts"
import style0 from "./SelectCasePageContent.vue?vue&type=style&index=0&id=4a0301a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0301a8",
  null
  
)

export default component.exports